import { Directive, Output, EventEmitter, Input } from '@angular/core';

import { Cell } from '../../../lib/data-set/cell';

@Directive()
export class DefaultEditor implements Editor {
  @Input() public cell: Cell;
  @Input() public inputClass: string;

  @Output() public onStopEditing = new EventEmitter<any>();
  @Output() public onEdited = new EventEmitter<any>();
  @Output() public onClick = new EventEmitter<any>();
  @Output() public blur = new EventEmitter<any>();
}

export interface Editor {
  cell: Cell;
  inputClass: string;
  onStopEditing: EventEmitter<any>;
  onEdited: EventEmitter<any>;
  onClick: EventEmitter<any>;
}
